export default "__VITE_ASSET__EeG5fVpZ__"